import { NgModule } from "@angular/core";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import { NgScrollbarModule } from 'ngx-scrollbar';
// import { SCROLLBAR_CONFIG } from 'ngx-scrollbar';
// import { ScrollbarConfigInterface } from 'ngx-scrollbar';


// const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//   suppressScrollX: true
// };

import { FormsModule,ReactiveFormsModule  } from "@angular/forms";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { FooterComponent } from "./footer/footer.component";
// import { VectorMapComponent1 } from "./vector-map/vector-map.component";

import { RouterModule } from "@angular/router";
import { CollapseModule } from "ngx-bootstrap/collapse";
// import { DxVectorMapModule, DxPieChartModule } from 'devextreme-angular';
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ChatChannelComponent } from './chat/chat-channel.component';
import { UploadFormComponent } from './upload-form/upload-form.component';
import { DropdownUploadFormComponent } from './dropdown-upload-form/dropdown-upload-form.component';
import { WarningIconComponent } from './warning-icon/warning-icon.component';
import { CharCounterComponent } from './char-counter/char-counter.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CollapseModule.forRoot(),
    NgScrollbarModule,
    BsDropdownModule.forRoot(),
    FormsModule,
    NgOptimizedImage,
    ReactiveFormsModule,
    // DxVectorMapModule,
    // DxPieChartModule
  ],
  declarations: [
    FooterComponent,
    // VectorMapComponent1,
    NavbarComponent,
    SidebarComponent,
    ChatChannelComponent,
    UploadFormComponent,
    DropdownUploadFormComponent,
    WarningIconComponent,
    CharCounterComponent
  ],
  exports: [
    FooterComponent,
    // VectorMapComponent1,
    NavbarComponent,
    SidebarComponent,
    ChatChannelComponent,
    UploadFormComponent,
    DropdownUploadFormComponent,
    WarningIconComponent,
    CharCounterComponent
  ],
  // providers: [
  //   {
  //     provide: PERFECT_SCROLLBAR_CONFIG,
  //     useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
  //   }
  // ]
})
export class ComponentsModule {}
